/**
 * @file マスタメンテナンスの入力フィールドを追加する
 */
'use strict'

import ApplyClass from '../../Utils/ApplyClass'
import Validate from './Validate'

/**
 * @classname BtnAddMasterMaintenanceItemField
 * @classdesc マスタメンテナンスの入力フィールドを追加する
 */
export default class BtnAddMasterMaintenanceItemField {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-add-master-maintenance-item-field')
	 */
	constructor($e, controller) {
		console.log('BtnAddMasterMaintenanceItemField.constructor')
		this._$e = $e
		this._controller = controller
		this._sortableListName = this._$e.data('sortable-list-name')
		this._$sortableList = $(`.sortable-list[data-sortable-list-name="${this._sortableListName}"]`)
		this._$lastSortableItem = this._$sortableList.find('.sortable-list__item').last()
		this._surrogateKeyName = this._$lastSortableItem.find('.surrogate_key').attr('name')
		this._inputName = this._sortableListName === 'specified-contribution-type' ? this._$lastSortableItem.find('.specified_contribution').attr('name') : this._$lastSortableItem.find('.display_name').attr('name')
		this._checkbtnName = this._$lastSortableItem.find('.input-checkbtn-input').attr('name')
		this._lastSortableItemIndex = this._$lastSortableItem.find('[data-sortable-list-item-index]').data('sortable-list-item-index')
		this._$titleFields = null
		this._$e.on('click', () => this.addNewField())
	}


	/**
	 * テンプレート
	 *
	 * @memberof BtnAddMasterMaintenanceItemField
	 * @return {undefined}
	 */
	createNewField() {
		console.log('BtnAddMasterMaintenanceItemField.createNewField')
		const newField = document.createElement('div')
		newField.classList.add('sortable-list__item', 'row')
		console.log(`this._sortableListName: ${this._sortableListName}`)
		switch (this._sortableListName) {
			case 'specified-contribution-type':
				newField.innerHTML = `
<div class="col-12 form-group">
	<input class="surrogate_key" type="hidden" name="${this._surrogateKeyName}" value="">
	<div class="d-flex align-items-center">
		<input class="validate w100 input-text" name="${this._$lastSortableItem.find('.specified_contribution_id').attr('name')}" data-validate="empty" data-sortable-list-item-index="1" type="text">
		<input class="validate input-text2 ml15" name="${this._inputName}" value="" data-validate="empty" data-sortable-list-item-index="${++this._lastSortableItemIndex}" type="text">
		<div class="input-checkbtn mt0 mb0 mr0 ml15">
			<input class="input-checkbtn-input" type="checkbox" id="${this._checkbtnName}_${this._lastSortableItemIndex}" name="${this._checkbtnName}" value="1">
			<label class="mb0 input-checkbtn-label text-nowrap" for="${this._checkbtnName}_${this._lastSortableItemIndex}">非表示</label>
		</div>
		<i class="fas fa-arrows-alt ml15 sortable-list__item__handle cursor-move fs24"></i>
	</div>
	<div class="d-flex align-items-center" style="display: none !important;">
		<p class="error-tip">
			<span class="error-tip-inner"></span>
		</p>
	</div>
</div>`
				break
			default:
				newField.innerHTML = `
<div class="col-12 form-group">
	<input class="surrogate_key" type="hidden" name="${this._surrogateKeyName}" value="">
	<div class="d-flex align-items-center">
		<input class="validate input-text" name="${this._inputName}" value="" data-validate="empty" data-sortable-list-item-index="${++this._lastSortableItemIndex}" type="text">
		<div class="input-checkbtn mt0 mb0 mr0 ml15">
			<input class="input-checkbtn-input" type="checkbox" id="${this._checkbtnName}_${this._lastSortableItemIndex}" name="${this._checkbtnName}" value="1">
			<label class="mb0 input-checkbtn-label text-nowrap" for="${this._checkbtnName}_${this._lastSortableItemIndex}">非表示</label>
		</div>
		<i class="fas fa-arrows-alt ml15 sortable-list__item__handle cursor-move fs24"></i>
	</div>
	<div class="d-flex align-items-center">
		<p class="error-tip">
			<span class="error-tip-inner"></span>
		</p>
	</div>
</div>`
				break
		}
		return newField
	}

	/**
	 * 起動
	 *
	 * @memberof BtnAddMasterMaintenanceItemField
	 * @return {undefined}
	 */
	addNewField() {
		console.log('BtnAddMasterMaintenanceItemField.addNewField')
		const $newField = $(this.createNewField())
		$newField.find('.validate').each((_, element) => ApplyClass.apply(Validate, $(element), [$(element), this._controller]))
		this._$sortableList.append($newField)
	}
}
